import * as React from "react"
import * as Model from "../../../../model"

export default class BudgetFormPart
extends React.Component<Props, State> {
    private currentYear = new Date().getFullYear()
    constructor(props: Readonly<Props>) {
		super(props)
		this.state = {
			years: this.createYears(props)
		}
	}
render() {
    const togglers = [
        {
            label: "Compilation des Dettes réelles",
            name: Names.dettesReelles
        },{
            label: "Compilation des Dettes Simulées",
            name: Names.dettesSimulées
        },{
            label: "Compilation des Dettes Globales",
            name: Names.dettesGlobales
        },
    ]
    if(this.props.localAuthority && this.props.localAuthority.members && this.props.localAuthority.members.length) {
        togglers.unshift({
            label: "Compilation des budgets annexes",
            name: Names.budgetsAnnexes
        })
    }
    return <section className="section">
        <h2>Budgets Annexes</h2>
        {togglers.map((toggler, i)=> {
           return this.renderField(toggler.name, toggler.label, i)
        })}
        </section>
    }
    private renderField(
        name: string,
        label: string,
        key?: number
    ): React.ReactNode {
        return <div className="field" key={key}>
            <label className="checkbox">
                <input name={name} type="checkbox" />&nbsp;{label}
            </label>
        </div>
    }
    private createYears(props: Readonly<Props>): number[] {
        const reference = props.scenario ? props.scenario.year : this.currentYear
        const end = reference + 6
        const start = end - 12
        const years: number[] = []

        for (let year = start; year < end; year++) years.push(year)

        return years
    }

}

export const Names = {
    budgetsAnnexes: 'budget-annexes',
    dettesReelles: 'dettes-reelles',
    dettesSimulées: 'dettes-simulees',
    dettesGlobales: 'dettes-globales'
};
    export interface Props {
        scenario?: Model.Scenario
        localAuthority?: Model.LocalAuthority
    }

    interface State {

    }



// WEBPACK FOOTER //
// ./src/component/management-report/form-parts/budget-form-part/index.tsx